var _g, _g2, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTaeger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1768 679",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1006.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ArtBoard1",
    transform: "matrix(1.0268,0,0,1,-110.789,807.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.897,
    y: 199.099,
    width: 1721.51,
    height: 678.825,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.973901,0,0,1,48.6201,0.0994002)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.401,263.532L387.387,264.486L377.603,334.746L169.464,334.733L180.401,263.532Z",
    style: {
      fill: "rgb(67,127,249)",
      stroke: "rgb(67,127,249)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-18.5949,114.224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.401,263.532L387.387,264.486L377.603,334.746L169.464,334.733L180.401,263.532Z",
    style: {
      fill: "rgb(249,98,67)",
      stroke: "rgb(249,98,67)",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-33.2649,227.462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.401,263.532L387.387,264.486L377.603,334.746L169.464,334.733L180.401,263.532Z",
    style: {
      fill: "rgb(218,249,67)",
      stroke: "rgb(218,249,67)",
      strokeWidth: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-18.2592,55.0023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.88,0,0,1,47.8981,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(280,0,0,280,1940.24,502.205)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "399.151px",
    y: "502.205px",
    style: {
      fontFamily: "'Arial-BoldItalicMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontStyle: "italic",
      fontSize: 280
    }
  }, "ventservice")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.973901,0,0,1.43144,56.2007,-356.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.43144,0,0,1,-217.208,0)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(144.173,0,0,144.173,1096.26,795.016)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "503.445px",
    y: "795.016px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "144.173px"
    }
  }, "TA", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "687.674px ",
    y: "795.016px "
  }, "E")), "GER"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTaeger);
export default __webpack_public_path__ + "static/media/logo_taeger.709eed09ab12bc5b491a07b2204cc0c1.svg";
export { ForwardRef as ReactComponent };